import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import localstorage from "./utils/localstorage";
import store from "./store";
import api from "./api"; // 导入api接口
import base from "./api/base"; // 导入api接口
import util from "./utils/utils"
import axios from "axios";
import Echarts from "echarts";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import ViewUI from "view-design";
import BaiduMap from "vue-baidu-map";
import "view-design/dist/styles/iview.css";
import lodash from "lodash";
import VueLazyload from 'vue-lazyload'
//import $ from 'jquery'
import {
  Button,
  Pagination,
  Swipe,
  List,
  PullRefresh,
  SwipeItem,
  RadioGroup,
  Rate,
  Tab,
  Tabs,
  Tag,
  DropdownMenu,
  Uploader,
  DropdownItem,
  Radio,
  Cell,
  Dialog,
  CellGroup,
  Area,
  DatetimePicker,
  SwipeCell,
  Checkbox,
  CheckboxGroup,
  Search,
  Col,
  Icon,
  Field,
  Image,
  NavBar,
  Picker,
  Popup,
  Row,
  Toast,
  Tabbar,
  TabbarItem,
} from "vant";
Vue.use(VueLazyload)
Vue.use(Field)
  .use(PullRefresh)
  .use(Rate)
  .use(Swipe)
  .use(SwipeItem)
  .use(Button)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Image)
  .use(Popup)
  .use(Picker)
  .use(Toast)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(NavBar);
Vue.use(Tabbar)
  .use(Pagination)
  .use(Uploader)
  .use(List)
  .use(Tag)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(TabbarItem)
  .use(Radio)
  .use(RadioGroup)
  .use(Icon)
  .use(Search)
  .use(Cell)
  .use(CellGroup)
  .use(Area)
  .use(DatetimePicker)
  .use(Dialog)
  .use(SwipeCell);
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$base = base; // 将api挂载到vue的原型上
//Vue.prototype.$toastVue.prototype.$api = api; // 将api挂载到vue的原型上 = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$localstorage = localstorage;
Vue.prototype.$axios = axios;
Vue.prototype.echarts = Echarts;
Vue.prototype.$lodash = lodash;
Vue.use(ElementUI);

Vue.use(ViewUI);
Vue.locale = () => {};
Vue.use(Echarts);
Vue.use(BaiduMap, {
  ak: "8oGIXq7E7OFkDOVzEbiwu5giDGYMCewQ",
});

// 使用方法2: 自定义参数选项配置
Vue.use(VueLazyload, {
  preLoad: 1.3, // 提前加载高度（数字 1 表示 1 屏的高度） 默认值:1.3
  attempt: 3 //  加载错误后最大尝试次数 默认值:3
})

Vue.prototype.$util = util;



Vue.filter("dataFormat", function(value, fmt) {
  if (null == value || value == "") {
    return "-";
  }
  let getDate;
  if (typeof value == "string") {
    getDate = new Date(value.replace(/\-/g, "/"));
  } else {
    getDate = new Date(value);
  }
  let o = {
    "M+": getDate.getMonth() + 1,
    "d+": getDate.getDate(),
    "h+": getDate.getHours(),
    "m+": getDate.getMinutes(),
    "s+": getDate.getSeconds(),
    "q+": Math.floor((getDate.getMonth() + 3) / 3),
    S: getDate.getMilliseconds(),
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
});

Vue.filter("fixed", function(value, e) {
  if (value == null || value == "" || isNaN(value)) {
    return "-";
  }

  return value.toFixed(e);
});

new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});
